export default __webpack_public_path__ + "static/media/edital52024final.79c4911a.pdf";